import { CssClassName } from '../generateCssClassName/types';

interface Props {
  children: any;
  id: string;
  hideFlag: boolean;
}

const CustomComponentWrapper = ({ children, id, hideFlag }: Props): any => {
  switch (id) {
    case CssClassName.KIOSK:
      return hideFlag ? null : children;

    default:
      return children;
  }
};

export default CustomComponentWrapper;
